// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".persistent-search[data-v-041db561]{box-shadow:0 2px 2px 0 rgba(84,110,122,.06),0 3px 1px -2px rgba(84,110,122,.12),0 1px 5px 0 rgba(84,110,122,.2)}@media(min-width:768px){.persistent-search[data-v-041db561]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
